module.exports = __webpack_public_path__ + "static/join-group-side-e3c7145a758425ee1e661ab4f4c6b88d.png";